import EurostatComparison from './EurostatComparison';

const EurostatComparisonConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/eurostatComparisons',
            element: <EurostatComparison />,
        },
    ],
};

export default EurostatComparisonConfig;
